import { lazy } from "react";

const PostCastSessionsList = lazy(() => import("./list.js"));
const PostCastSessionDetails = lazy(() => import("./session-detail.js"));
const SessionAnalysis = lazy(() => import("./session-analysis.js"));
const PostsView = lazy(() => import("./posts-view.js"));

export {
  PostCastSessionsList,
  PostCastSessionDetails,
  SessionAnalysis,
  PostsView
};
